
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import LoadingDots from './LoadingDots';
import Loader from './Loader';

const ListingStep14 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [price, setPrice] = useState(0); 
  const [hostFee, setHostFee] = useState(0);
  const [guestServiceFee, setGuestServiceFee] = useState(0);
  const [affiliateId, setAffiliateId] = useState('');
  const [userEarns, setUserEarns] = useState(0);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const numericPrice = parseFloat(price) || 0;
  const guestPriceBeforeTaxes = (numericPrice + parseFloat(guestServiceFee)).toFixed(2);
  const spanRef = useRef(null);
  const inputRef = useRef(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (spanRef.current && inputRef.current) {
      spanRef.current.textContent = price || '';
      inputRef.current.style.width = spanRef.current.offsetWidth + 50 + 'px';
    }
  }, [price]);

  const handlePriceChange = (e) => {
    let value = e.target.value;
    value = value.replace(/^0+/, '');
    if (/^\d{0,6}$/.test(value)) {
      setPrice(value);
    }

    if (value.length == 0){
      setPrice(0)
    }
  };

  useEffect(() => {

    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);
          setCategoryId(listingData.category_id);

          try {
            setPrice(listingData.listing_price || 0);
            setHostFee(listingData.listing_host_fees || 0);
            setAffiliateId(listingData.affiliate_id || '');
            setLoading(false);
          } catch (error) {
            toast.error('Error parsing listing data: ' + error.message);
            console.error('Parsing error:', error);
            setLoading(false);
          }
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    const fetchCategories = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getCategories}`,
          data: formData,
        });
  
        if (response.data.status === 'category') {
          setCategories(response.data.property_cat_list);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        toast.error(err.message);
      }
    };
  
    fetchListingData();
    fetchCategories();
  }, [listingId]); 

  useEffect(() => {
    if (categoryId && categories.length > 0) {
      const category = categories.find(cat => cat.category_id === categoryId);
      if (category) {
        const guestFeePercentage = parseFloat(category.guest_service_fees) || 0;
        const hostFeePercentage = parseFloat(category.host_service_fees) || 0;
  
        const calculatedGuestFee = ((numericPrice * guestFeePercentage) / 100).toFixed(2);
        const calculatedHostFee = ((numericPrice * hostFeePercentage) / 100).toFixed(2);
        const userEarns = (numericPrice - calculatedHostFee).toFixed(2);

        setUserEarns(userEarns);
        setHostFee(calculatedHostFee);
        setGuestServiceFee(calculatedGuestFee);
      }
    }
  }, [categoryId, categories, numericPrice]);

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const listing_id = listingId;
      const ts = Date.now();
    
      const updatedPropertyItem = {
        listing_price: price,
        listing_guest_fees: guestServiceFee,
        listing_host_fees: hostFee
      };

      const mergedData = { ...listingData, ...updatedPropertyItem };
    
      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listing_id);
      catData.append('data', JSON.stringify(mergedData)); 
      catData.append('ts', ts); 

      setNextLoading(true);
    
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });
    
        if (response.data.status === 'done') {
          return true;
        } else {
          toast.error('Failed to save data');
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

    

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-14' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>

      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 14)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
              <div>
                <h4 className='ws-title'>Now, set your price</h4>
                <p class="ws-desc">Modifications can be made at any time.</p>
              </div>
          </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>
              <div className='col-md-12 text-center mb-3'>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div
                    className='clsp-div'
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                    }}
                  >
                    <img
                      src='/assets/img/icons/rupee-currency.svg'
                      className='rupee-icon img-fluid'
                      alt='₹'
                      style={{
                        position: 'absolute',
                        left: '0',
                        top: '34%',
                        transform: 'translateY(-50%)',
                        width: '36px',
                        pointerEvents: 'none',
                      }}
                    />
                    <input
                      ref={inputRef}
                      type='text'
                      className='price-input'
                      value={price}
                      onChange={handlePriceChange}
                      style={{
                        paddingLeft: '35px',
                        fontSize: '52px',
                        width: '180px',
                        textAlign: 'left',
                        border: 0,
                      }}
                      placeholder='0'
                    />
                    <span
                      ref={spanRef}
                      style={{
                        position: 'absolute',
                        visibility: 'hidden',
                        whiteSpace: 'pre',
                        fontSize: '52px',
                        fontFamily: 'inherit',
                        paddingLeft: '35px',
                      }}
                    />
                  </div>
                </div>

                <div className='clspb-div'>
                  <div className='clspb-box'>
                    <span>Base Price</span>
                    <div>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      <span>{numericPrice.toFixed(2)}</span>
                    </div>
                  </div>
                  <div className='clspb-box'>
                    <span>Guest Service Fee</span>
                    <div>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      <span>{guestServiceFee}</span>
                    </div>
                  </div>
                  <div className='clspb-box'>
                    <span>Guest Price Before Taxes</span>
                    <span>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      <span>{guestPriceBeforeTaxes}</span>
                    </span>
                  </div>
                </div>
                
                <div className='clspb-div'>
                  <div className='clspb-box border-0'>
                    <span>Base Price</span>
                    <span>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      {numericPrice.toFixed(2)}
                    </span>
                  </div>
                  <div className='clspb-box border-0'>
                    <span>Host Service Fee</span>
                    <span>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      {hostFee}
                    </span>
                  </div>
                  <div className='clspb-box border-0'>
                    <span>Earning</span>
                    <span>
                      <img src='/assets/img/icons/rupee-currency.svg' className='span-rupee-icon img-fluid' alt='₹' /> 
                      {userEarns}
                    </span>
                  </div>
                  { affiliateId && (
                    <div className='affiliate-calculation-box'>
                      <p className='aff-calc-title'>Your earning after Affiliate Charges</p>
                      <div className='affiliate-calc'>
                        <div className='aff-calc-img'>
                          <img src={'/assets/img/icons/wsac_1.svg'} alt="Notification" className="wsac-icon" />
                          <span>month 10% of {userEarns} = {(userEarns * 0.1).toFixed(2)}</span>
                        </div>
                        <span><i class="fa-solid fa-indian-rupee-sign"></i> {(userEarns - userEarns * 0.1).toFixed(2)}</span>
                      </div>
                      <div className='affiliate-calc'>
                        <div className='aff-calc-img'>
                          <img src={'/assets/img/icons/wsac_2.svg'} alt="Notification" className="wsac-icon" />
                          <span>month 5% of {userEarns} = {(userEarns * 0.05).toFixed(2)}</span>
                        </div>
                        <span><i class="fa-solid fa-indian-rupee-sign"></i> {(userEarns - userEarns * 0.05).toFixed(2)}</span>
                      </div>
                      <div className='affiliate-calc'>
                        <div className='aff-calc-img'>
                          <img src={'/assets/img/icons/wsac_3.svg'} alt="Notification" className="wsac-icon" />
                          <span>month 3% of {userEarns} = {(userEarns * 0.03).toFixed(2)}</span>
                        </div>
                        <span><i class="fa-solid fa-indian-rupee-sign"></i> {(userEarns - userEarns * 0.03).toFixed(2)}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep14;
